// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__25Rbp","header":"ClearentDisclaimer_header__2QGGc","inner":"ClearentDisclaimer_inner__2PUXT"};